<div class="section-wrapper" *ngIf="operatingModesActive$ | async | ready">
  <h3 class="static-heading">
    {{ '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.OPERATING_MODE.TITLE' | translate }}
  </h3>
  <app-circuit-operating-mode-panel [circuitId]="circuitId"> </app-circuit-operating-mode-panel>
</div>

<div
  *ngIf="(devicesStore.isSelectedDeviceOBNG$ | async) && roomDetails$ | async as feature"
  class="section-wrapper"
>
  <h3 class="static-heading">
    {{ '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.OVERLAY_HEADER' | translate }}
  </h3>
  <button
    mat-stroked-button
    gtm="onSelect"
    gtmAction="Go to reference room overlay"
    gtmCategory="installationDetails"
    (click)="openReferenceRoomOverlay(feature)"
  >
    {{ '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.REFERENCE_ROOM' | translate }}
  </button>
</div>

<div class="section-wrapper" *ngIf="heatingZoneDemand$ | async | ready as feature">
  <h3 class="static-heading">
    {{
      '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.EXTERNAL_ROOM_HOOKUP.TITLE' | translate
    }}
  </h3>
  <app-feature-list-item
    data-at-heating-circuit-0-zone-demand
    label="{{
      '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.EXTERNAL_CONTACT_STATUS.TITLE'
        | translate
    }}:"
    value=" {{
      (feature?.properties?.present.value
        ? '+INSTALLATIONS.INSTALLATION.CIRCUIT.ZONE_CONTACT_CLOSED'
        : '+INSTALLATIONS.INSTALLATION.CIRCUIT.ZONE_CONTACT_OPEN'
      ) | translate
    }}
    "
    [attr.data-feature]="feature.feature"
  >
  </app-feature-list-item>
</div>

<div class="sections-wrapper">
  <app-temperature-schedule-manager [circuitId]="circuitId"> </app-temperature-schedule-manager>

  <div *ngIf="heatingCurve$ | async | ready" class="section-wrapper">
    <h3>
      {{ '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.HEATING_CURVE.TITLE' | translate }}
    </h3>
    <app-heat-curve-panel [circuitId]="circuitId"></app-heat-curve-panel>
  </div>
</div>

<div
  *ngIf="devicesStore.isRemoteControllerOrClimateSensorAvailable$ | async"
  class="sections-wrapper"
>
  <app-vitotrol-remote-controller
    [featureName]="featureNames.heatingCircuitRemoteController(circuitId)"
  >
  </app-vitotrol-remote-controller>
</div>
